angular.module('stonehenge')
.factory('componentService', [ '$http', function($http) {
    return {
        get : function(id) {
            return $http.get('api/users/' + id)
        },
        add: function(user){
            return $http.post('api/users/add', user)
        },
        find: function(filter){
            return $http.post('api/users/', filter)
        },
        update: function(user){
            return $http.put('api/users/update', user)
        },
        remove: function(id){
            return $http.delete('api/users/' + id)
        }
    };
} ]);
